import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialForm = {
  name: '',
  email: '',
  phone: '',
  company: '',
  service: '',
  message: '',
};

export const submitContactForm = createAsyncThunk(
  'contact/submitContactForm',
  async (formData, thunkAPI) => {
    // Simulate network request - replace with real API call if needed
    await new Promise((r) => setTimeout(r, 700));

    // Example: pretend success if email present
    if (!formData || !formData.email) {
      throw new Error('Email is required');
    }

    return { id: Date.now(), ...formData };
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    formData: { ...initialForm },
    isSubmitting: false,
    submitSuccess: false,
    submitError: null,
  },
  reducers: {
    updateFormField(state, action) {
      const { field, value } = action.payload;
      state.formData[field] = value;
      // Reset previous submit state on change
      state.submitError = null;
      state.submitSuccess = false;
    },
    resetForm(state) {
      state.formData = { ...initialForm };
      state.isSubmitting = false;
      state.submitSuccess = false;
      state.submitError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = null;
        state.submitSuccess = false;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.submitSuccess = true;
        state.submitError = null;
        // Optionally clear form
        state.formData = { ...initialForm };
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitSuccess = false;
        state.submitError = action.error?.message || 'Failed to submit form';
      });
  },
});

export const { updateFormField, resetForm } = contactSlice.actions;
export default contactSlice.reducer;
